import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { movieGridView } from '../constants';
// eslint-disable-next-line @typescript-eslint/no-var-requires
import gameSystemImage from 'common/assets/magicMovie/game-diagram-system-01.png';

interface MagicMovieDiagramProps {
  onChangeView: (view: string) => void;
}

export const MagicMovieDiagram: React.FC<MagicMovieDiagramProps> = (props) => {
  const { t } = useTranslation(['magicMovie']);
  const { onChangeView } = props;
  const [messageText, setMessageText] = useState('');
  const messages = useMemo(
    () => [
      t('diagram.message1'),
      t('diagram.message2'),
      t('diagram.message3'),
      t('diagram.message4'),
      t('diagram.message5'),
      t('diagram.message6'),
      t('diagram.message7'),
      t('diagram.message8'),
    ],
    [t]
  );

  useEffect(() => {
    messages.map((messageText, index) => {
      return setTimeout(() => {
        setMessageText(messageText);
      }, 2000 * index);
    });

    setTimeout(() => {
      onChangeView(movieGridView.recommendedMovies);
    }, 16000);
  }, [messages, onChangeView]);

  return (
    <div id="game" className="statusDiagramContainer">
      <div className="statusDiagram" style={{ backgroundImage: 'url(' + gameSystemImage + ')' }}></div>
      <div className="statusDiagramMessage">
        <h4 id="diagramMessage">{messageText}</h4>
      </div>
    </div>
  );
};

export default MagicMovieDiagram;
